import { LoginService } from "./../login/login.service";
import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { LocalStorageService } from "src/app/utils/localstorage.service";
import { environment } from "../../environments/environment";

/**
Class used to extend the CanActivate method. It's used to run a piece of code
before a route to check if it can be activated or not
*/
@Injectable()
export class ClientGuard {
  constructor(
    public router: Router,
    public localStorage: LocalStorageService,
    public loginService: LoginService,
  ) {}

  /**
   * Checks if user has access_token in localStorage.
   */
  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (
      this.loginService.get_access_token() !== undefined &&
      this.loginService.get_access_token() != null
    ) {
      if (this.localStorage.get("data")["user_type"] == 2) {
        return true;
      } else {
        const url = state.url ?? "";
        const practiceUrl = url.startsWith("/client")
          ? url.replace("/client", "/practice")
          : "/practice";
        this.router.navigateByUrl(practiceUrl).catch((error) => {
          if (error?.code === 4002) {
            return this.router.navigateByUrl("/practice/workspaces");
          }
          throw error;
        });
        return false;
      }
    }
  }
}
